var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.166016C4.40033 0.166016 0.666992 3.89935 0.666992 8.49935C0.666992 13.0993 4.40033 16.8327 9.00033 16.8327C13.6003 16.8327 17.3337 13.0993 17.3337 8.49935C17.3337 3.89935 13.6003 0.166016 9.00033 0.166016ZM7.33366 12.666L3.16699 8.49935L4.34199 7.32435L7.33366 10.3077L13.6587 3.98268L14.8337 5.16602L7.33366 12.666Z",
    fill: "#0FAF51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.49730bd241c3a4e5aed8fd4e93e1c09e.svg";
export { ForwardRef as ReactComponent };